"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingTie = exports.SpinnerWrapper = exports.Container = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  width: 36px;\n  height: 24px;\n\n  &::before,\n  &::after {\n    content: '';\n    display: inline-block;\n    width: 0;\n    height: 0;\n    position: absolute;\n    top: 50%;\n    transform: translate(0, -50%);\n    border-top: 12px solid transparent;\n    border-bottom: 12px solid transparent;\n  }\n\n  &::before {\n    border-left: 18px solid black;\n    left: 0;\n    animation: ", ";\n  }\n\n  &::after {\n    border-right: 18px solid black;\n    right: 0;\n    animation: ", ";\n    animation-delay: 0.5s;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: table-cell;\n  text-align: center;\n  vertical-align: middle;\n  transform-origin: center center;\n  padding: 15px;\n  animation: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: table;\n  width: 100%;\n  height: 100%;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", " 1s infinite;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", " 1.1s cubic-bezier(0.2, 0.3, 0.3, 1) infinite;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  0% { opacity: 1; }\n  70% { opacity: .3; }\n  100% { opacity: 1; }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% { transform: rotate(0deg); }\n  70%,100% { transform: rotate(540deg); }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Animations


var rotateAnimation = (0, _styledComponents.keyframes)(_templateObject());
var pulseAnimation = (0, _styledComponents.keyframes)(_templateObject2());
var rotateAnimationRule = (0, _styledComponents.css)(_templateObject3(), rotateAnimation);
var pulseAnimationRule = (0, _styledComponents.css)(_templateObject4(), pulseAnimation); // Styled Components

var Container = _styledComponents.default.div(_templateObject5());

exports.Container = Container;

var SpinnerWrapper = _styledComponents.default.div(_templateObject6(), function (props) {
  return props.rotateSpinner ? rotateAnimationRule : "none";
});

exports.SpinnerWrapper = SpinnerWrapper;

var LoadingTie = _styledComponents.default.div(_templateObject7(), function (props) {
  return props.pulse ? pulseAnimationRule : "none";
}, function (props) {
  return props.pulse ? pulseAnimationRule : "none";
});

exports.LoadingTie = LoadingTie;